define('helpers/d3pie',['require','exports','module','d3','d3pie'],function(require, exports, module) {
    "use strict";

    require("d3");
    var currentD3Pie = require("d3pie");

    module.exports = {
        getD3Pie: function() {
            return currentD3Pie;
        },
        setD3Pie: function(D3pie) {
            currentD3Pie = D3pie;
        }
    };

});

